module.exports = "<app-graph-visual #graph></app-graph-visual>"